import { Check, Loader2, AlertCircle, CloudOff } from 'lucide-react';

/** Tiny status pill for a useAutoSave hook — shows Saving / Saved / Error. */
export default function AutoSaveIndicator({ status, lastSaved, className = '' }) {
  const fmt = lastSaved
    ? new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(lastSaved)
    : null;

  let body = null;
  if (status === 'saving') {
    body = (
      <span className="inline-flex items-center gap-1.5 text-zinc-300">
        <Loader2 size={11} className="animate-spin" /> Saving…
      </span>
    );
  } else if (status === 'saved') {
    body = (
      <span className="inline-flex items-center gap-1.5 text-emerald-300">
        <Check size={11} /> Saved{fmt ? ` · ${fmt}` : ''}
      </span>
    );
  } else if (status === 'error') {
    body = (
      <span className="inline-flex items-center gap-1.5 text-red-300">
        <AlertCircle size={11} /> Couldn't save — retry in a moment
      </span>
    );
  } else {
    body = (
      <span className="inline-flex items-center gap-1.5 text-zinc-500">
        <CloudOff size={11} /> Auto-save ready
      </span>
    );
  }
  return (
    <div
      className={`text-[11px] font-semibold tracking-wide ${className}`}
      data-testid="autosave-indicator"
      aria-live="polite"
    >
      {body}
    </div>
  );
}
